module.exports = __webpack_public_path__ + "static/media/Decoration_Camping.867be08c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Camping.png
// module id = 1343
// module chunks = 3